<template>

<van-button v-if="!showDoc"   class="m-r1" size="small"  type="primary">
  <Spinner />
</van-button>

<van-button v-if="showDoc" @click="GoFicheTech(item)"  class="m-r1" size="small"  type="primary">
    <van-icon name="description"  size="17px" /> 
</van-button>


</template>

<script>

import Spinner from '../../loader/LoaderSimple.vue' ;
export default {
  props: ['item'],
  components: {
    Spinner,
  },
  data() {
    return {
      //showDoc: false,
    }
  },
  mounted(){
    //this.globalFunction.logConfiguration(this, this.item)
    this.CreateFicheTech(this.item)
    //console.log(process.env.VUE_APP_URL_API)
  },
  computed: {
    showDoc() {
      return !this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.includes(this.item.id_perso);
    },
  },
  created() {
   
      },
  methods:{

     GoFicheTech(item){

        var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
        window.open(this.$store.state.storeGlobal.StoreApi + '/pdf/' + ref_prk + '.pdf', '_blank');

        //this.showDoc = false;
          
          /*
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL("http://localhost:8080/pdf/PRK_8PKM3LCLC120.pdf");
        a.download = "FILENAME.pdf";
        a.click();
        */
      

    },

    CreateFicheTech(item){
   
      //this.showDoc = item.id_perso;
      //this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus[item.id_perso] = item.id_perso;
      const id_perso = item.id_perso;
      //this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', id_perso)
      // emit an event to signal the change
      //this.$emit('StorePrePanierFicheTechniqueStatusUpdated');
      item.lang = this.$i18n.locale;
      fetch(this.$store.state.storeGlobal.StoreApi + '/fiche-technique', {
        method: "POST",
        headers: {
              'Content-Type': 'application/json'
            },
        body: JSON.stringify(item),
        mode: 'no-cors',
      }
      ) 
      .then((response) => { 
        return response; 
      })
      .then(() => {

     /*
        var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
    
        window.open(this.$store.state.storeGlobal.StoreApi + '/pdf/' + ref_prk + '.pdf', '_blank');
*/
        //this.showDoc = false;
        //this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus[item.id_perso] = false;
        this.$store.commit('REMOVE_FICHE_TECHNIQUE_STATUS', id_perso)
        //this.$emit('StorePrePanierFicheTechniqueStatusUpdated');
          /*
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL("http://localhost:8080/pdf/PRK_8PKM3LCLC120.pdf");
        a.download = "FILENAME.pdf";
        a.click();
        */
      });

    },

   
}
}

</script>

<style>

</style>

